import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class CommunitySearchBaseComponent extends BaseComponent {
  public text: string = "CommunitySearch";

  constructor(userService: UserService) {
    super(userService);
  }
}
